import React, { useEffect, useRef, useState } from "react";
import { cn } from "@/utils/cn";
import GradientOutline from "../GradientOutline/GradientOutline";

const InputV2 = ({
  fieldLabel,
  startIcon,
  endIcon,
  endIconBorder = true,
  containerClassName = "",
  fieldLabelclassName = "",
  inputclassName = "",
  endIconClassName = "",
  hint,
  ...props
}) => {
  const containerInputRef = useRef(null);

  const [openCalendar, setOpenCalendar] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!containerInputRef?.current?.contains(event.target)) {
        setOpenCalendar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className={cn("flex flex-col gap-y-[6px]", containerClassName)}>
      {fieldLabel && (
        <label
          className={cn(
            {
              "text-[16px] leading-[16px] font-light after:content-['*'] after:text-[#AE1C28]":
                props.required,
            },
            fieldLabelclassName
          )}
          htmlFor={props.htmlFor}
        >
          {fieldLabel}
        </label>
      )}

      <GradientOutline
        ref={containerInputRef}
        filled={!!props.value && !props.error}
        error={!!props.error}
        className="h-10"
      >
        <div
          className={cn("flex h-full items-center relative", inputclassName)}
        >
          {startIcon && (
            <div className="w-10 h-full flex items-center justify-center border-e-[1px] border-[#141218]/40">
              {startIcon}
            </div>
          )}

          <input
            {...props}
            placeholder={props.error || props.placeholder}
            autoComplete="off"
            className={cn(
              "flex-1 h-full px-2 text-[14px] leading-[14px] font-light outline-none bg-transparent",
              props.error
                ? "!text-[#AE1C28] placeholder:!text-[#AE1C28]"
                : "text-[#141218] placeholder:!text-[#141218]",
              props.className
            )}
          />

          {endIcon && (
            <div
              className={cn(
                "w-10 h-full flex items-center justify-center",
                {
                  "border-s-[1px] border-[#141218]/40": endIconBorder,
                },
                endIconClassName
              )}
              onClick={() =>
                props.type === "date" && setOpenCalendar(!openCalendar)
              }
            >
              {endIcon}
            </div>
          )}
        </div>
      </GradientOutline>

      {/* {props.error && !!props.value && (
        <div className="text-[#AE1C28] mt-[3px] text-[14px] leading-[14px] font-light">
          {props.error}
        </div>
      )} */}

      {hint && (
        <div className="text-[#141218] text-[14px] leading-[14px] font-light italic mt-[3px]">
          {hint}
        </div>
      )}
    </div>
  );
};

export default InputV2;
